import { Dialog, DialogContent, DialogTrigger, SafeGuardStyle, DialogClose } from 'views/Forms/ModalStyled';
import React from 'react';
import { ReactComponent as KeyIcon } from 'assets/Icons/KeyIcon.svg';
import { FormSubmitBtn } from 'views/Forms/FormsStyled';
import { HeaderSignupButton } from '../HeaderStyled';
import { Box } from 'components/Box';
import { setUser } from 'state/user';
import { useAppDispatch } from 'state';

const LogoutModal: React.FC = () => {
    const dispatch = useAppDispatch();

    return (
        <Dialog>

            <DialogTrigger asChild>
                <HeaderSignupButton>Logout</HeaderSignupButton>
            </DialogTrigger>

            <DialogContent>

                <SafeGuardStyle>
                    <KeyIcon />
                </SafeGuardStyle>

                <Box style={{ marginTop: '2rem', textAlign: 'center', }}>
                    <span>Are you sure you want to Logout?</span>
                </Box>

                <form style={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}>
                    <FormSubmitBtn style={{ width: '40%' }}>
                        <button type="submit" style={{ margin: '30px 0px' }} onClick={() => { localStorage.removeItem('Gamesfi_Current_User'); dispatch(setUser({ authToken: "", user: null })) }}>Yes</button>
                    </FormSubmitBtn>

                    <DialogClose asChild>
                        <FormSubmitBtn style={{ width: '40%' }}>
                            <button type="submit" style={{ margin: '30px 0px' }}>No</button>
                        </FormSubmitBtn>
                    </DialogClose>

                </form>
            </DialogContent>

        </Dialog >
    )
}

export default LogoutModal;